import React, { useState } from 'react';
import './MessageCodes.css';
import ReactDOM from 'react-dom';

const A1Popup = ({ item }) => {
    const [showPopup, setShowPopup] = useState(false);

    const togglePopup = () => {
        setShowPopup(!showPopup);
    };

    const handleOverlayClick = (e) => {
        if (e.target.classList.contains('popup-fullscreen-overlay')) {
            setShowPopup(false);
        }
    };

    if (!item?.text) return null;

    const renderPopupContent = () => {
        if (item?.url) {
            return (
                <div className="popup-fullscreen-content">
                    <p>Document is available at:</p>
                    <a
                        href={item?.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="popup-link"
                    >
                        Open Document
                    </a>
                    <p className="popup-note">(This will open in a new tab)</p>
                </div>
            );
        }

        if (item?.data) {
            return (
                <div
                    className="popup-fullscreen-content"
                    dangerouslySetInnerHTML={{ __html: item?.data }}
                />
            );
        }

        return (
            <div className="popup-fullscreen-content">
                <p>No content available</p>
            </div>
        );
    };

    // Create portal element if it doesn't exist
    const portalRoot = document.getElementById('popup-portal') ||
        (() => {
            const el = document.createElement('div');
            el.id = 'popup-portal';
            document.body.appendChild(el);
            return el;
        })();

    if (!showPopup) {
        return (
            <div className="popup-container">
                <div
                    className="chat-label action-tab"
                    onClick={togglePopup}
                >
                    {item?.text}
                </div>
            </div>
        );
    }

    // Use ReactDOM.createPortal to render outside the widget
    return ReactDOM.createPortal(
        <div className="popup-fullscreen-overlay" onClick={handleOverlayClick}>
            <div className="popup-fullscreen-wrapper">
                <button className="popup-close" onClick={togglePopup}>×</button>
                {renderPopupContent()}
            </div>
        </div>,
        portalRoot
    );
};

export default A1Popup;